import React, { useEffect } from 'react'
import {motion} from "framer-motion"
import '../components/Styles/home.css'
import '../components/Styles/About.css'
import xm1 from '../assets/images/ex1.png'
import xm2 from '../assets/images/ex2.png'
import ab1 from '../assets/images/ov5.png'
import ab2 from '../assets/images/ov8.png'
import ab3 from '../assets/images/ov7.png'
import ab4 from '../assets/images/ov3.png'
import ab5 from '../assets/images/ov9.png'
import ab6 from '../assets/images/ov6.png'
import ab7 from '../assets/images/ov2.png'
import ab8 from '../assets/images/aba4.png'
import v1 from '../assets/images/v1.png'
import v2 from '../assets/images/v2.png'
import v3 from '../assets/images/v3.png'
import v4 from '../assets/images/v4.png'
import AOS from 'aos';
import 'aos/dist/aos.css';
import Slide from './Slide'


const About = () => {
  useEffect(()=>{
    AOS.init();
   
  })
const IconCalendar = () => (
  <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path
      d="M7 3v3M17 3v3M4.5 8.5h15"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
    />
    <path
      d="M6 5h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2z"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinejoin="round"
    />
    <path
      d="M8 12h3M8 15h3M14 12h2"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
    />
  </svg>
);

/* renamed to avoid conflict with IconPhone above */
const IconCall = () => (
  <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path
      d="M7 3h4l2 5-2 1c1 2.8 3.2 5 6 6l1-2 5 2v4c0 1-1 2-2 2C10 21 3 14 3 5c0-1 1-2 2-2h2z"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinejoin="round"
    />
  </svg>
);
  return (
    <div>
         <section className="ab_main">
        <div className="ab_main_sec">
          <h1>
Built for Professionals Wh
Take Their Busines 
                 <span style={{ color: "#EEBD2B" }}>            Seriously
</span>

        </h1>


           <p>Xceed Office was created with a clear purpose: to provide structured, executive workspace  solutions for professionals who understand that environment influences perception.  We are not a casual coworking space. </p>
        
              <button> Schedule a Private Tour    </button> &nbsp;
    
        </div>
      </section>

       <section style={{background:"#171717ff"}} className="philo">
      <div className="philo__container">
        <div className="philo__grid">
          {/* LEFT */}
          <div className="philo__content">
            <p className="philo__kicker">OUR PHILOSOPHY</p>

            <h2 className="philo__title">
              Environment Shape <br />
              <span>Perception</span>
            </h2>

            <p className="philo__lead">
              Where you work affects how clients see you.
              <br />
              It affects how your team performs.
              <br />
              It affects how you think.
            </p>

            <p className="philo__text">
              Xceed Office locations are carefully selected inside Class A buildings in
              Houston’s most recognized business districts. We prioritize prestige,
              accessibility, and long-term stability over trend-driven design.
            </p>

            <p className="philo__text">This is intentional.</p>
          </div>

          {/* RIGHT */}
          <div className="philo__media">
            <div className="philo__imageCard">
              <img className="philo__image" src={xm1} alt="Office interior" />
            </div>
          </div>
        </div>
      </div>
    </section>
 <section className="serve">
  <div className="serve__container">

    <div className="serve__header">
      <p className="serve__kicker">OUR CLIENTELE</p>
      <h2>Who We <span>Serve</span></h2>
    </div>

    <div className="serve__grid">

      <div className="serve__card">
        <div className="serve__icon"><img src={ab1} alt="" /></div>
        <h3>Law Firms</h3>
        <p>Professional address and confidential meeting spaces.</p>
      </div>

      <div className="serve__card">
        <div className="serve__icon"><img src={ab2} alt="" /></div>
        <h3>Financial Advisors</h3>
        <p>Client-facing offices that inspire confidence.</p>
      </div>

      <div className="serve__card">
        <div className="serve__icon"><img src={ab3} alt="" /></div>
        <h3>Real Estate Brokerages</h3>
        <p>Prestigious presence in Houston’s prime corridor.</p>
      </div>

      <div className="serve__card">
        <div className="serve__icon"><img src={ab4} alt="" /></div>
        <h3>Consultants</h3>
        <p>Flexible workspace that scales with your engagements.</p>
      </div>

      <div className="serve__card">
        <div className="serve__icon"><img src={ab5} alt="" /></div>
        <h3>Sales Organizations</h3>
        <p>Structured environments for high-performance teams.</p>
      </div>

      <div className="serve__card">
        <div className="serve__icon"><img src={ab6} alt="" /></div>
        <h3>Investment Professionals</h3>
        <p>Executive suites befitting your clientele.</p>
      </div>

      <div className="serve__card">
        <div className="serve__icon"><img src={ab7} alt="" /></div>
        <h3>International Companies</h3>
        <p>Turnkey Houston market entry with instant credibility.</p>
      </div>

      <div className="serve__card">
        <div className="serve__icon"><img src={ab8} alt="" /></div>
        <h3>Professional Services</h3>
        <p>Operational infrastructure from day one.</p>
      </div>

    </div>
  </div>
</section>
<section  style={{background:"#171717ff"}} className="edge">
  <div className="edge__container">

    <div className="edge__header">
      <p className="edge__kicker">OUR EDGE</p>
      <h2>What Makes Xceed <span>Different</span></h2>
    </div>

    <div className="edge__grid">

      <div className="edge__card">
        <div className="edge__icon"><img src={v1} alt="" /></div>
        <div>
          <h3>Executive Positioning</h3>
          <p>
            We operate inside premier business corridors such as Uptown Houston
            and the Post Oak district, ensuring that your address carries weight.
          </p>
        </div>
      </div>

      <div className="edge__card">
        <div className="edge__icon"><img src={v2} alt="" /></div>
        <div>
          <h3>Structured Support</h3>
          <p>
            Professional front desk reception, mail handling, call answering,
            and booking systems are built to support your daily operations.
          </p>
        </div>
      </div>

      <div className="edge__card">
        <div className="edge__icon"><img src={v3} alt="" /></div>
        <div>
          <h3>Flexible Without Compromise</h3>
          <p>
            Traditional leases require long commitments, capital investment,
            and infrastructure buildout. Xceed memberships remove that burden
            while maintaining executive presence.
          </p>
        </div>
      </div>

      <div className="edge__card">
        <div className="edge__icon"><img src={v4} alt="" /></div>
        <div>
          <h3>Designed for Growth</h3>
          <p>
            Whether starting with a virtual office or operating from a
            dedicated private suite, our solutions scale with your business.
          </p>
        </div>
      </div>

    </div>

  </div>
</section>
<section className="ourLoc">
  <div className="ourLoc__container">
    <div className="ourLoc__grid">
      {/* LEFT */}
      <div className="ourLoc__content">
        <p className="ourLoc__kicker">STRATEGIC PRESENCE</p>

        <h2 className="ourLoc__title">
          Our <span>Locations</span>
        </h2>

        <p className="ourLoc__text">
          Xceed Office currently operates in Houston’s most respected commercial
          districts, including Uptown and the Galleria area.
        </p>

        <ul className="ourLoc__list">
          <li className="ourLoc__item">
            <span className="ourLoc__dot">✓</span>
            Class A building quality
          </li>
          <li className="ourLoc__item">
            <span className="ourLoc__dot">✓</span>
            Corporate environment standards
          </li>
          <li className="ourLoc__item">
            <span className="ourLoc__dot">✓</span>
            Premium accessibility &amp; parking
          </li>
          <li className="ourLoc__item">
            <span className="ourLoc__dot">✓</span>
            Long-term strategic value
          </li>
        </ul>
      </div>

      {/* RIGHT */}
      <div className="ourLoc__media">
        <div className="ourLoc__imageCard">
          {/* replace src with your image import */}
          <img
            className="ourLoc__image"
            src={xm2}
            alt="Conference room"
          />

          <div className="ourLoc__label">
            <span className="ourLoc__pin" />
            Uptown Houston · Galleria Area
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<section  style={{background:"#171717ff"}} className="forward">
  <div className="forward__container">
    <header className="forward__header">
      <h2 className="forward__title">
        Looking <span>Forward</span>
      </h2>
      <p className="forward__sub">As we expand, our focus remains the same:</p>
    </header>

    <div className="forward__grid">
      <div className="forwardCard">
                    <span className="ourLoc__dot">✓</span>

        <p className="forwardCard__text">Premium locations.</p>
      </div>

      <div className="forwardCard">
            <span className="ourLoc__dot">✓</span>
        <p className="forwardCard__text">Structured operations.</p>
      </div>

      <div className="forwardCard forwardCard--center">
            <span className="ourLoc__dot">✓</span>
        <p className="forwardCard__text">Serious professionals.</p>
      </div>
    </div>
  </div>
</section>
    <section  className="cta">
        <div className="cta__wrap">
          <h2 className="cta__title">
            Ready to Elevate Your <br />
            <span>Business Presence?</span>
          </h2>

          <p className="cta__sub">
            Join professionals who trust Xceed Office for their workspace <br />
            needs.
          </p>

          <div className="cta__actions">
            <button className="cta__btn cta__btn--primary" type="button">
              <span className="cta__btnIcon"><IconCalendar /></span>
              Schedule a Tour <span className="cta__arrow">→</span>
            </button>

            <button className="cta__btn cta__btn--ghost" type="button">
              <span className="cta__btnIcon"><IconCall /></span>
              Call Now
            </button>
          </div>


        </div>
      </section>

    </div>
  )
}

export default About